import _ from 'lodash';

export default function getTimestampRanges(startDate, endDate){
  let delta = endDate - startDate;
  let divider = 0, loopCounter = 0;
  
  while(divider < 12) {
    divider = findBestDivider(delta+loopCounter);
    loopCounter++;
  }

  let sumCounter = loopCounter === 0 ? delta/divider :(delta+(loopCounter-1))/divider;
  let ranges = [];

  for(var i=0; i<divider; i++) {
    ranges.push({
      startDate: startDate + sumCounter * i,
      endDate: (startDate + sumCounter * (i + 1)) - 1
    });
  }
  return ranges;
}

function findBestDivider(n) {
	if (n < 1)
		throw "Argument error";
	let small = [];
	let large = [];
	let end = Math.floor(Math.sqrt(n));
	for (var i = 1; i <= end; i++) {
		if (n % i == 0) {
			small.push(i);
		}
	}
	large.reverse();

  let dividers = small.concat(large);
  dividers.pop();
  dividers.shift();

  let bestDivider = 0;
  _.map(dividers, (divider) => {
    if(divider > 12 && divider < 20 && Number.isInteger(n/divider))
      bestDivider = divider;
  });

  return bestDivider;
}



// WEBPACK FOOTER //
// ./src/businessLogic/getTimestampRanges.js